import React from 'react';
import { Button, Form, Modal } from 'antd';
import { useIntl } from 'react-intl';
import ApplicationForm from '../ApplicationForm';
import { ModalProps } from '@/types/ModalProps';
import { useDefaultFormErrorNotification } from '@/hooks';
import { TaskApplicationFormValues } from '@/core/domain/operational/TaskAppllication/TaskApplication.types';

interface Props extends ModalProps {
  onOk: (values: TaskApplicationFormValues) => Promise<void>;
  isLoading: boolean;
}

function ApplicationModal({ onOk, visible, handleVisible, isLoading }: Props) {
  const intl = useIntl();
  const [form] = Form.useForm<TaskApplicationFormValues>();
  const { sendFormErrorNotification } = useDefaultFormErrorNotification();

  const handleCancel = () => {
    form.resetFields();
    handleVisible();
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      await onOk(values);

      form.resetFields();
    } catch (err) {
      sendFormErrorNotification(err);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={handleCancel}
      destroyOnClose
      title={intl.formatMessage({
        id: 'task.application.modal.addApplication',
      })}
      footer={[
        <Button type="primary" ghost onClick={handleCancel}>
          {intl.formatMessage({ id: 'commons.modal.button.cancel' })}
        </Button>,
        <Button type="primary" onClick={handleOk} loading={isLoading}>
          {intl.formatMessage({ id: 'commons.modal.button.save' })}
        </Button>,
      ]}
    >
      <ApplicationForm form={form} />
    </Modal>
  );
}

export default ApplicationModal;
